
// Typescript es5 bug workaround
// The Date object doesn't follow Typescript's expectations about how a super class behaves.
// In particulary, TS, when targetting es5, transpiles inheritance into a call to super.call(this).  
// Date returns a *string* in that scenario, not a Date object, which causes problems down the line.
// _Date intercepts the call to super() and returns null, which causes TS's transpiled code to revert to the actual 'this'
// object instead of hte string returned by null.
class _Date extends Date {
    constructor() {
        super();
        return null as any as Date;
    }
}

export default class TZDate extends _Date {
    private _local : Date;
    private _utc : Date;
    private _offset : number;

    constructor();
    constructor(d : TZDate);
    constructor(d : number);
    constructor(d : string);
    constructor(d : number, tz : number);
    constructor(arg1? : any, arg2? : any) {
        super();
        var local : Date, 
            utc : Date, 
            offset : number, 
            d : TZDate, 
            str : string, 
            m : RegExpExecArray | null, 
            secs : number, 
            msecs : number;

        if (arguments.length === 0) {
            msecs = Date.now();

            utc = new Date(msecs);
            offset = utc.getTimezoneOffset();
            local = new Date(msecs - offset * 60000);
        } else if (arguments.length === 1 && arg1 instanceof TZDate) {
            d = arg1;

            local = new Date(d._local.getTime());
            utc = new Date(d._utc.getTime());
            offset = d._offset;
        } else if (arguments.length === 1 && typeof arg1 === 'number') {
            msecs = arg1;

            utc = new Date(msecs);
            offset = utc.getTimezoneOffset();
            local = new Date(msecs - offset * 60000);
        } else if (arguments.length === 1 && typeof arg1 === 'string') {
            str = arg1;

            if (m = ISO8601ZPattern.exec(str)) {
                // ISO8601 time string ending in 'Z' for UTC time

                secs   = +m[6] || 0;
                msecs  = Math.round((secs - Math.floor(secs)) * 1000);
                secs   = Math.floor(secs);
                utc    = new Date(Date.UTC(+m[1] || 0, (+m[2] || 1) - 1, +m[3] || 1, +m[4] || 0, +m[5] || 0, secs, msecs));
                local  = new Date(+utc);
                offset = 0;

            } else if (m = ISO8601OffsetPattern.exec(str)) {
                // time string ends in a numeric offset, like "+05:00"

                secs   = +m[6] || 0;
                msecs  = Math.round((secs - Math.floor(secs)) * 1000);
                secs   = Math.floor(secs);
                local  = new Date(Date.UTC(+m[1] || 0, (+m[2] || 1) - 1, +m[3] || 1, +m[4] || 0, +m[5] || 0, secs, msecs));
                offset = (m[7] === '-' ? 1 : -1) * (+m[8] * 60 + (+m[9] || 0));
                utc    = new Date(+local + offset * 60000);
            } else if (m = DotNetOffsetPattern.exec(str)) {

                utc    = new Date(+m[1]);
                offset = +m[2] || 0;
                local  = new Date(+utc - offset * 60000);

            } else {
                // no timezone info in string, use ambient timezone
                local  = new Date(str);
                offset = local.getTimezoneOffset();
                utc    = new Date(+local + offset * 60000);
            }

        } else if (arguments.length === 2 && typeof arg1 === 'number' && typeof arg2 === 'number') {
            msecs = arg1;

            utc = new Date(msecs);
            offset = arg2;
            local = new Date(msecs - offset * 60000);
        } else {
            throw new Error("TZDate: unrecognized parameters");
        }

        this._local = local;
        this._utc = utc;
        this._offset = offset;
    }
    getDate            () { return this._local.getUTCDate(); };
    getDay             () { return this._local.getUTCDay(); };
    getFullYear        () { return this._local.getUTCFullYear(); };
    getHours           () { return this._local.getUTCHours(); };
    getMilliseconds    () { return this._local.getUTCMilliseconds(); };
    getMinutes         () { return this._local.getUTCMinutes(); };
    getMonth           () { return this._local.getUTCMonth(); };
    getSeconds         () { return this._local.getUTCSeconds(); };
    getYear            () { return this._local.getUTCFullYear() - 1900; };
    getUTCDate         () { return this._utc.getUTCDate(); };
    getUTCDay          () { return this._utc.getUTCDay(); };
    getUTCFullYear     () { return this._utc.getUTCFullYear(); };
    getUTCHours        () { return this._utc.getUTCHours(); };
    getUTCMilliseconds () { return this._utc.getUTCMilliseconds(); };
    getUTCMinutes      () { return this._utc.getUTCMinutes(); };
    getUTCMonth        () { return this._utc.getUTCMonth(); };
    getUTCSeconds      () { return this._utc.getUTCSeconds(); };
    setDate            (n : number) { this._local.setUTCDate(n);            return this.syncDates(false);   }
    setFullYear        (n : number) { this._local.setUTCFullYear(n);        return this.syncDates(false);   }
    setHours           (n : number) { this._local.setUTCHours(n);           return this.syncDates(false);   }
    setMilliseconds    (n : number) { this._local.setUTCMilliseconds(n);    return this.syncDates(false);   }
    setMinutes         (n : number) { this._local.setUTCMinutes(n);         return this.syncDates(false);   }
    setMonth           (n : number) { this._local.setUTCMonth(n);           return this.syncDates(false);   }
    setSeconds         (n : number) { this._local.setUTCSeconds(n);         return this.syncDates(false);   }
    setYear            (n : number) { this._local.setUTCFullYear(n + 1900); return this.syncDates(false);   }
    setUTCDate         (n : number) { this._utc.setUTCDate(n);              return this.syncDates(true); }
    setUTCFullYear     (n : number) { this._utc.setUTCFullYear(n);          return this.syncDates(true); }
    setUTCHours        (n : number) { this._utc.setUTCHours(n);             return this.syncDates(true); }
    setUTCMilliseconds (n : number) { this._utc.setUTCMilliseconds(n);      return this.syncDates(true); }
    setUTCMinutes      (n : number) { this._utc.setUTCMinutes(n);           return this.syncDates(true); }
    setUTCMonth        (n : number) { this._utc.setUTCMonth(n);             return this.syncDates(true); }
    setUTCSeconds      (n : number) { this._utc.setUTCSeconds(n);           return this.syncDates(true); }
    getTime            () { return this._utc.getTime(); }
    setTime            (n : number) { this._utc.setTime(n); return this.syncDates(true); }
    getTimezoneOffset  () { return this._offset; }
    setTimezoneOffset  (n : number, changeUtc = false) { this._offset = n; this.syncDates(!changeUtc); return this; }
    toBrowserLocalDate () { return new Date(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds()); }
    toBrowserUTCDate   () { return this._utc; }
    toDateString       () {
        return this.getFullYear()
            + '/' + pad(this.getMonth() + 1, 2, '0')
            + '/' + pad(this.getDate(), 2, '0');
    }
    toISOString() {
        var o = this.getTimezoneOffset(),
            s = this.getFullYear()
                + '-' + pad(this.getMonth() + 1, 2, '0')
                + '-' + pad(this.getDate(), 2, '0')
                + 'T' + pad(this.getHours(), 2, '0')
                + ':' + pad(this.getMinutes(), 2, '0')
                + ':' + pad(this.getSeconds(), 2, '0');

        if (this.getMilliseconds()) {
            s += (this.getMilliseconds() / 1000).toFixed(3).substr(1);
        }

        if (o === 0) {
            s += 'Z';
        } else {
            var neg = o < 0,
                h = Math.floor(Math.abs(o) / 60),
                m = Math.abs(o) % 60;

            s += (neg ? '+' : '-')
                + pad(h, 2, '0')
                + ':' + pad(m, 2, '0');
        }

        return s;
    }
    toJSON             () { return this.toISOString(); }
    toLocaleDateString () { return this.toDateString(); }
    toLocaleString     () { return this.toString(); }
    toLocaleTimeString () { return this.toTimeString(); }
    toString           () { return this.toDateString() + ' ' + this.toTimeString(); }
    toTimeString() {
        var h = ((this.getHours() + 11) % 12) + 1,
            pm = this.getHours() > 11;

        return pad(h, 2, '0')
            + ':' + pad(this.getMinutes(), 2, '0')
            + ':' + pad(this.getSeconds(), 2, '0')
            + ' ' + (pm ? 'PM' : 'AM');
    }
    toUTCString        () { return this._utc.toUTCString(); }
    valueOf            () { return this._utc.valueOf(); }
    
    // when a change is made to one date, make a parallel change for the same amount of seconds to the other date
    // parameter is:
    //  d - the date (local or UTC) that is to be synched
    private syncDates(local : boolean) {
        if (local) this._local.setTime(this._utc.getTime() - this._offset * 60000);
        else       this._utc.setTime(this._local.getTime() + this._offset * 60000);
        return +this._utc;
    }

    static eq(a : TZDate, b : TZDate) {
        return a.getTime() === b.getTime() && a.getTimezoneOffset() === b.getTimezoneOffset();
    }

    static nullableEq(a : TZDate | null, b : TZDate | null) {
        return a && b && TZDate.eq(a, b) || !a && !b;
    }
}

// Date match patterns.  Exposed on constructor so other modules may use them if they desire.
var ISO8601ZPattern      = /^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d(?:\.\d+)?))?Z$/,
    ISO8601OffsetPattern = /^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d(?:\.\d+)?))?(\+|-| )(\d\d):?(\d\d)?$/,
    DotNetOffsetPattern  = /^Date((\d+)(\+|\-)(\d+))$/;

// pad the given string-convertible item to the given length using the given pad character
function pad(s : any, len : number, c : string) {
    s = s.toString();
    while (s.length < len) s = c + s;
    return s;
}


// WEBPACK FOOTER //
// ./lib/TZDate.ts